<template>
  <div id="assetQRcode">
    <table>
      <thead>
        <tr>
          <th
            class="title"
            colspan="4"
          >
            智生活 / 資產QR Code
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in assetUrlList"
          :key="index"
        >
          <td
            v-for="(assetItem, assetIndex) in item"
            :key="assetIndex"
          >
            <template v-if="assetItem">
              <img
                class="logo"
                src="@/assets/img/asset/logo.png"
                alt=""
              >
              <div class="QRbox">
                <div class="QRimg">
                  <vue-qr
                    :correct-level="3"
                    :dot-scale="1"
                    :text="assetItem.url"
                    :size="140"
                    :margin="0"
                  />
                </div>
              </div>
              <div class="txtbox">
                <span>{{ assetItem.name }}</span>
              </div>
            </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  computed: {
    assetUrlList () {
      const list = this.$store.state.asset.assetUrlList
      console.log(list)
      if (!list) return []
      const returnList = []
      list.forEach((item, index, arr) => {
        if (index % 4 === 0) {
          returnList.push([item, arr[index + 1], arr[index + 2], arr[index + 3]])
        }
      })
      return returnList
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="sass" scoped>
#assetQRcode
  width: 210mm
  min-height: 297mm
  padding: 0
  margin: 0 auto
  border: 1px #D3D3D3 solid
  border-radius: 5px
  background: white
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
  table
    width: 100%
    .title
      font-size: 25px
      font-weight: bold
      padding: 15px 16px
      text-align: left
    td
      width: 25%
      border: 1px solid #ddd
      position: relative
      text-align: center
      .logo
        position: absolute
        top: 20px
        left: 50%
        margin-left: -70px
        width: 140px
      .QRbox
        text-align: center
        padding-top: 30px
        .QRimg
          width: 140px
          height: 140px
          margin: 25px auto
      .txtbox
        padding: 0 10px
        margin-top: -25px
        margin-bottom: 10px
        width: 100%
        display: table
        span
          font-weight: bold
          font-size: 19px
          display: table-cell
          height: 58px
          overflow: hidden
          vertical-align: middle
          width: 100%
</style>
